import { render, staticRenderFns } from "./_infoDrug.vue?vue&type=template&id=34b876ca"
import script from "./_infoDrug.vue?vue&type=script&lang=js"
export * from "./_infoDrug.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports